import styled from "styled-components";

const PlaylistCardContainer = styled.div`
  width: 100%;
  padding: 8px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey};
`;

const PlaylistImageContainer = styled.div`
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 6px;
`;

const PlaylistImage = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

export { PlaylistCardContainer, PlaylistImageContainer, PlaylistImage };
